import { useQuery } from '@tanstack/react-query';

import { luceneApi } from '../../shared/api';
import { queryIds } from '../../shared/utils/constants';

type Params = {
  countryCode: string;
  term: string;
};

type Options = {
  enabled?: boolean;
};

export const supportedCountryCodes = (import.meta.env.VITE_LUCENE_SUPPORTED_COUNTRY_CODES || 'BE')
  .split(',')
  .map((code: string) => code.trim().toUpperCase())
  .filter(Boolean);

const useGetPostalCodeCity = (params: Params, options: Options = {}) => {
  const enabled =
    options.enabled !== undefined
      ? options.enabled
      : !!(
          params.term &&
          params.term.length &&
          supportedCountryCodes.includes(params.countryCode.toUpperCase())
        );

  const { data, error, isFetching } = useQuery({
    enabled,
    queryFn: async () => {
      const result = await luceneApi.getPostalCodeCity(params);

      const formatted = result.data.map(({ id, postalCode, city }) => ({
        city,
        id,
        label: `${postalCode} - ${city}`,
        postalCode,
      }));

      return {
        formatted,
        result,
      };
    },
    queryKey: [queryIds.lucene.GET_POSTALCODE_CITY, params.term, params.countryCode],
    retry: 0,
  });

  return {
    error,
    isFetchingPostalCodeCity: isFetching,
    postalCodeCity: data?.result.data || [],
    postalCodeCityAutoComplete: data?.formatted || [],
  };
};
export default useGetPostalCodeCity;
